import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
`;

export const Tabs = styled.div`
  display: flex;
  margin: 21px 0;
  align-items: center;
  gap: 20px;
`;

export const Tab = styled.div`
  font-size: 14px;
  cursor: pointer;
  color: ${({ theme, active }) => (active ? theme.text.tableVulnNameConfirmed : theme.text.tableVulnName)};
  font-weight: ${({ active }) => active ? '600' : '400'};
`;
